import {
  CUSTOM_TAILWIND_CSS_DEVELOPMENT_PATH,
  CUSTOM_TAILWIND_CSS_PRODUCTION_PATH,
} from '../../constants';

export interface CreateTailwindLinkOptions {
  /**
   * 环境变量，用于决定使用开发环境还是生产环境的样式表路径
   */
  environment?: 'production' | 'development';
  /**
   * 是否采用预加载
   */
  preload?: boolean;
}

export function createTailwindLink(options: CreateTailwindLinkOptions) {
  const { environment = 'development', preload } = options;

  const link = document.createElement('link');

  if (preload) {
    link.setAttribute('rel', 'preload');
    link.setAttribute('as', 'style');
  } else {
    link.setAttribute('rel', 'stylesheet');
  }

  if (environment === 'development') {
    link.setAttribute('href', CUSTOM_TAILWIND_CSS_DEVELOPMENT_PATH);
  } else {
    link.setAttribute('href', CUSTOM_TAILWIND_CSS_PRODUCTION_PATH);
  }

  return link;
}
